import moment from "moment";

export const formatCurrency= (n) => {
    if (n) {
      var parts = n.toString().split(".");
      const numberPart = parts[0];
      const decimalPart = parts[1];
      const thousands = /\B(?=(\d{3})+(?!\d))/g;
      let v = "$"+numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : ".00");
      if (decimalPart?.length===1 ) {
          v+='0'
      }
      return v;
    }
    return "$0.00"
  };


  export const formatThousands= (n) => {
    return (n) ? n.toLocaleString('en') : "0"
  };

  export const formatDate= (n) => {
    return (n) ? moment(n).format("MM-DD-YYYY") : ""
  };


  export const toMoney = (number) => {
    if (!number) {
      number = 0
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
      number
    );
  }

  export const toMoneyWhole = (number) => {
    if (!number) {
      number = 0
    }
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', currency: 'USD', minimumFractionDigits: 0, }).format(
        number
    );

  }

  export const getFilename = (fullPath) => {
    if (!fullPath) {
      return '';
    }
    return fullPath.replace(/^.*[\\\/]/, '');
  };